<template lang="html">
  <div id="d-text-page-1">
    <div class="box-white-s1">
      <div class="basic-info">
        <h1 class="title">{{row.name}}</h1>
        <!-- <h4 class="subtitle">Ejemplo de subtítulo más largo para esta pagina</h4> -->
      </div>

      <div class="box-description" v-html="row.description"></div>

      <a class="btn btn-sm btn-info" :href="row.documentUrl" target="_blank" style="background-color: black; border-color: black;margin-top: 5px;" v-if="row.documentUrl"> Descargar PDF</a>
      <a class="btn btn-sm btn-info" :href="row.documentUrlTwo" target="_blank" style="background-color: black; border-color: black;margin-top: 5px;" v-if="row.documentUrlTwo"> Descargar PDF</a>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      row:[],
    }
  },

  methods: {

    getRow(){
      axios.get(tools.url("/api/politics/"+this.id)).then((response)=>{
          this.row = response.data;
      }).catch(()=>{});
    }
  },
  mounted(){
    this.id = this.$route.params.id;
      this.getRow();
  }
}
</script>